<app-panel
  [panelTitle]="activity?.name"
  [isOpen]="isOfferPanelOpen"
  (panelClose)="closePanel()"
>
  <ng-container panel-header-content #headerContent>
    <div class="text-left text-xs flex flex-wrap gap-2 mt-3">
      <app-badge *ngIf="selectedTimeslot" [variant]="badgeGreyVariant">
        <time
          class="timeslot__start-date"
          [attr.datetime]="
            selectedTimeslot?.startDate | localizedDate: 'y-MM-dd'
          "
        >
          {{ formattedTimeslotDate }}
        </time>
      </app-badge>

      <app-badge [ngClass]="capacityClass" [variant]="badgeGreyVariant">
        <vtmn-play-icon
          class="mr-1"
          [name]="iconType?.User"
          [ariaLabel]="'a11y.offer.timeslot.capacity_icon.label' | translate"
        ></vtmn-play-icon>
        <ng-container *ngIf="!selectedTimeslot?.remainingAttendeeCapacity">
          {{ 'timeslot.full' | translate }}
        </ng-container>

        <ng-container *ngIf="selectedTimeslot?.remainingAttendeeCapacity">
          {{ selectedTimeslot.remainingAttendeeCapacity }}
          {{ 'timeslot.remaining_spots' | translate }}
        </ng-container>
      </app-badge>
    </div>

    <p
      *ngIf="hasStreetAddress || hasLocalityInformation"
      class="text-grey-dark-3 not-italic text-xs text-left mt-2"
    >
      <span class="block" *ngIf="hasStreetAddress">
        {{ activity?.location?.address?.streetAddress }}
      </span>
      <span class="block" *ngIf="hasLocalityInformation">
        {{ activity?.location?.address?.postalCode }}
        {{ activity?.location?.address?.addressLocality }}
      </span>
    </p>
  </ng-container>

  <ng-container panel-content>
    <section>
      <div class="activity-component__timeslot-container flex w-full">
        <app-offer-collection
          *ngIf="offers"
          [offers]="offers"
          [activity]="activity"
          [isMobileDevice]="isMobileDevice"
          (selectedOffer)="selectOffer($event)"
          class="flex-shrink-0 w-full"
        ></app-offer-collection>
      </div>
    </section>
  </ng-container>

  <ng-container panel-footer #footerContent>
    <button
      app-vtmn-play-button
      class="pb-3 w-full"
      type="button"
      [type]="ctaButtonType.Button"
      [size]="vtmnPlayButtonSize.MEDIUM"
      [shape]="vtmnPlayButtonShape.SQUARED"
      [disabled]="!offer ? true : null"
      [attr.data-disabled]="!offer ? true : null"
      (click)="onValidateSelection()"
    >
      <span class="pr-1" *ngIf="offer">
        {{ offer.price | displayPrice: offer.currency }}
        <span *ngIf="isBg && offer.price !== 0">
          - {{ offer.price | priceConversion | displayPrice: '€' }}</span
        >
      </span>
      {{ 'activity.offers.button' | translate }}
    </button>
  </ng-container>
</app-panel>

<app-attendee-activity-timeslot-list
  [timeslots]="timeslots"
  [activity]="activity"
  [hasSeeMoreUrl]="hasSeeMoreUrl"
  [hasPagination]="hasPagination"
  [hasLoadMoreButton]="hasLoadMoreButton"
  (selectTimeslot)="selectTimeslot($event)"
  (cancelTimeslot)="deleteTimeslot($event)"
  (loadMore)="loadMore()"
></app-attendee-activity-timeslot-list>
